import React, { Component } from 'react'
import styled from 'styled-components'
import { Container, Row, Col, media } from 'styled-bootstrap-grid'

export default class Callout extends Component {
  render() {
    const { text } = this.props

    return (
      <Wrapper>
        <Container fluid>
          <Row>
            <Col>
              <Text>{text}</Text>
            </Col>
          </Row>
        </Container>
      </Wrapper>
    )
  }
}

// Styles
const Wrapper = styled.div`
  margin-bottom: 65px;
`

const Text = styled.h2`
  text-align: center;
  font-size: 65px;
  font-weight: 300;
  line-height: 80px;
  margin: 0;

  ${media.xs`
    font-size: 30px;
    line-height: normal;
  `}
`



// WEBPACK FOOTER //
// ./src/ui/components/modules/Callout/index.js